import React, { useState } from 'react';
import { useUpdateOpco } from '../../hooks/OpCo';
import useShowError from '../../hooks/useShowError';
import useShowToast from '../../hooks/useShowToast';
import { OperatingCompanyUpdate } from '../../api/generated';
import { useQueryClient } from '@tanstack/react-query';
import { ERROR_MESSAGES } from '../../constants/opCoConstants'
import OpCoForm from '../OpCoOnboardForm/OpCoForm';
interface IOpCoFormData {
    name: string;
    description: string;
    opco_code: string;
    invoiceemailid: string;
    rejectionemailtype: string;
    rejectemailid: string;
    po_feed: string;
    supplier_feed: string;
    transmittingsummaryinfo: string;
    invoice_feed: string;
    reconcilliation_feed: string;
    sla_invoiceprocessingdays: string;
    sla_invoiceoverduenotificationdays: string;
    worklistname: string;
    teamname: string;
    unprocessedemailid: string;
    invoiceretention: string;
    dataretention: string;
    emailprovider: string;
    erpprovider: string;
    additionalsystems: 'Yes' | 'No' | '';
    additionalsystemsdetails: string;
}

interface IOpCoFormDataWithId extends IOpCoFormData {
    id?: number;
}

export default function OpCoEditForm({ selectedMember, onCancelOpco }: { selectedMember: IOpCoFormDataWithId, onCancelOpco: () => void }) {
    const formData:IOpCoFormData = selectedMember;
    const showError = useShowError()
    const updateOpcoForm = useUpdateOpco().mutate
    const showSuccessToast = useShowToast()
    const queryClient = useQueryClient()

    const handleSubmit = (formData) => {
        updateOpcoForm({ id: selectedMember.id, ...formData }, {
            onSuccess: (response) => {
                showSuccessToast("Successfully updated Business Unit")
                queryClient.setQueryData(["opco"], (old: Array<OperatingCompanyUpdate>) => {
                    return old.map((item: any) => (item.id === response.id ? response : item))
                })
                onCancelOpco()
                queryClient.refetchQueries({queryKey:["teams"]})
            },
            onError: (error: any) => {
                if (error?.code === "ERR_NETWORK") {
                    showError(ERROR_MESSAGES.NETWORK);
                } else if (error) {
                    const status = error?.status
                    const detail = error?.body?.detail
                    if (status === 422 && Array.isArray(detail)) {
                        const messages = detail.map((item: any) => {
                            return `${item.msg}`
                        }).join('\n')
                        showError(`${messages}`)
                    } else if (status >= 500) {
                        showError(ERROR_MESSAGES.SERVER_500)
                    } else if (status >= 400 && status <= 500) {
                          if(typeof detail === 'string'){
                            showError(`${detail}`)
                        }else{
                        showError(ERROR_MESSAGES.SERVER_400)
                        }
                    }
                    else {
                        showError(ERROR_MESSAGES.UPDATE_COMPANY_FAILED)
                    }
                } else {
                    showError(`${error?.message || ERROR_MESSAGES.UNKNOWN}.`)
                }
            },
        })
    }

    return (
        <OpCoForm
            mode="edit"
            initialData={formData}
            onSubmit={handleSubmit}
            onCancel={onCancelOpco}
        />
    );
}
